import Assets from '@lib/Assets';
import Loader from '../common/Loader';
import IconArrowDown from '../icons/IconArrowDown';
import IconArrowDownCircle from '../icons/IconArrowDownCircle';
import IndexPageContext from '../index-table/IndexPageContext';
import IndexTableRowRenderer from '../index-table/IndexTableRowRenderer';
import ProjectStatusHelper from '../project/ProjectStatusHelper';
import ConfigTag from './../configurations/ConfigurationsTag';
import WarningsContainer from '../../components/common/WarningsContainer';

export default class ProjectsIndexTableRowRenderer extends IndexTableRowRenderer {

    renderNameColumn(column, value, children) {
        const warnings = [
            this.props.row.replacedInDocumentGeneratorWarning,
            this.props.row.anyRemovedComponentWarning,
            this.props.row.anyManuallyAddedComponentWarning
        ].filter(x => x).map(x => ({...x, text: __(x.text)}))

        return super.renderNameColumn(column, value, (
            <div>
                {this.props.row.so && <span className="name-sub-title">{__('SO')}: {this.props.row.so}</span>}
                {this.props.row.po && <span className="name-sub-title">{__('PO')}: {this.props.row.po}</span>}
                {warnings && warnings.length > 0 && (
                    <div style={{display: 'flex', marginTop: '5px'}}>
                        <WarningsContainer warning={warnings}/>
                    </div>
                )}
            </div>

        ))
    }

    renderIndexTableRow() {
        const rowClassName = this.props.row.hidden ? 'project--hidden' : '';

        return (
            <React.Fragment>
                <tr className={rowClassName}>
                    {this.indexTableRow.renderCheckbox()}
                    {this.indexTableRow.props.columns.map((column, idx) => (
                        <React.Fragment key={idx}>
                            {this.indexTableRow.renderDataCell(column, this.indexTableRow.findValueByColumnSlug(column.slug))}
                        </React.Fragment>
                    ))}
                    {this.indexTableRow.renderBaseActionButtons()}
                </tr>

                {this.renderConfigurations()}
            </React.Fragment>
        )
    }

    renderLastEditColumn(column, value) {
        if (this.props.row.canEdit === false) {
            return (
                <td>-</td>
            )
        }
        return (
            <td>
                <div>{value.date}</div>
                <div>{value.userName}</div>
            </td>
        );
    }

    renderConfigurations = () => {
        const configurations = this.indexTableRow.state.configurations || [];

        let isVisible = (slug) => configurations.columns.find(x => x.slug === slug).visible;
        let getColumnName = (slug) => <th>{configurations.columns.find(x => x.slug === slug).name}</th>
        let getColumnValue = (item, slug) => <td>{item[slug].value}</td>

        return this.indexTableRow.state.configurationOpen ?
            <React.Fragment>
                {this.indexTableRow.state.configurationsLoading && configurations.length === 0 ? (
                    <tr className="index-table-expanded-row loading">
                        <td colSpan="13">
                            <Loader/>
                        </td>
                    </tr>
                ) : (
                    <tr className="index-table-expanded-row">
                        <td></td>
                        <td colSpan="13">
                            <table>
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>{__('Product')}</th>
                                    <th>{__('Setup')}</th>
                                    <th>{__('Configured by')}</th>
                                    {isVisible('FactoryCost') && <th>{__('Factory cost')}</th>}
                                    {isVisible('DiscountedPrice') && getColumnName('DiscountedPrice')}
                                    {isVisible('Margin') && getColumnName('Margin')}
                                    <th>{__('Status')}</th>
                                    <th>{__('Last edited')}</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>

                                <tbody className="">
                                {configurations.items.map(c => (
                                    <tr className="index-table-expanded-row-row" key={c.id}>
                                        <td className="name-column">
                                            <span>{c.name}</span>
                                            <span>{c.number}</span>
                                            {(c.canSetProductSerialNumber && c.productSerialNumber) &&
                                                <span>{__('S/N')}: {c.productSerialNumber}</span>}
                                        </td>
                                        <td>{c.product}</td>
                                        <td>{c.setup}</td>
                                        <td>{c.configuredBy}</td>
                                        {isVisible('FactoryCost') && <td>{c.discountedFactoryCost}</td>}
                                        {isVisible('DiscountedPrice') && <td>{c.discountedPrice}</td>}
                                        {isVisible('Margin') && <td>{c.margin}</td>}
                                        <td>{ConfigTag.get(c.status)}</td>
                                        <td>
                                            <span>{c.lastEdit.item1}</span>
                                            <span>{c.lastEdit.item2}</span>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                )}

                <tr className="index-table-expanded-arrow">
                    <td colSpan="14" onClick={this.onHideConfigurationsClick}>
                        <div className="index-table-expanded-arrow-x">
                            <IconArrowDownCircle/>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
            : <React.Fragment></React.Fragment>;
    }


    hideButtonClick = (e, button, row, editAPIService) => {
        editAPIService.hide(row.id).then((response) => {
            let row = this.indexTableRow.state.row;
            row.hidden = response.data.isHidden;
            this.indexTableRow.setState({row: row});
            this.indexTableRow.onReloadCall();
        })
    }

    renderHideButtonAction(button, row, editAPIService) {
        let icon = this.indexTableRow.state.row.hidden ? 'visibleOnIcon' : 'visibleOffIcon';
        let canHide = this.indexTableRow.state.row.canHide
        if (!canHide) {
            icon = icon + "Gray";
        }
        return (
            <a key={row.guid} className={"index-action-button" + (canHide ? "" : " nonActive")}
               onClick={canHide ? e => this.hideButtonClick(e, button, row, editAPIService) : undefined}>
                <img src={Assets[icon]}/>
            </a>
        );
    }

    renderStatusColumn = (column, value) => {
        return <td>{value}</td>;
    }

    renderStatusColumn = (column, value) => {
        return <td className="index-type-column" key={column.slug}>
            <div className="type">
                {ProjectStatusHelper.getTag(this.props.row.type)}
                {this.props.row.canEdit === false ? "" : (<div
                    className={`type-substatus ${this.props.row.substatusSlug}-label`}>{this.props.row.substatusName}</div>)}
            </div>
        </td>;
    }

    renderDeleteButtonAction(button, row, editAPIService, buttonIndex) {
        let canDelete = row.canDelete;
        if (canDelete) {
            return this.indexTableRow.renderDeleteButtonAction(button, buttonIndex, editAPIService);
        }
        return (<div key={buttonIndex} className="index-action-button nonActive"></div>)
    }

    renderParticipantsColumn(column, value) {
        return (<td className="index-participants-column" key={column.slug}>
            {(value.length > 0) ? value.map(v => <p key={this.getRandomKey()}>{v}</p>) : "-"}
        </td>)
    }

    renderViewersColumn(column, value) {
        value = value || []
        return (<td className="index-viewers-column" key={column.slug}>
            {(value.length > 0) ? value.map(v => <p key={this.getRandomKey()}>{v}</p>) : "-"}
        </td>)
    }


    onShowConfigurationsClick = (e, editAPIService) => {
        let isOpen = this.indexTableRow.state.configurationOpen;

        this.indexTableRow.setState({
            configurationOpen: !isOpen,
            configurationsLoading: true
        });

        if (!isOpen) {
            editAPIService.getConfigurationsList(e).then(response => {
                this.indexTableRow.setState({
                    configurations: response.data,
                    configurationsLoading: false
                });
            });
        }
    }

    onHideConfigurationsClick = () => {
        this.indexTableRow.setState({
            configurationOpen: false
        });
    }

    renderConfigurationsColumn(column, value) {
        if (this.props.row.canEdit === false) {
            return (
                <td>-</td>
            )
        }
        return (
            <IndexPageContext.Consumer key={this.getRandomKey()}>
                {({editAPIService}) => (
                    <React.Fragment>
                        <td className="index-configurations-column" key={column.slug}>
                            {value}

                            {Number(value) > 0 && (
                                <div
                                    className={`configurations-show-button ${this.indexTableRow.state.configurationOpen ? 'open' : ''}`}
                                    onClick={e => this.onShowConfigurationsClick(this.props.row.id, editAPIService)}
                                >
                                    {/* <span>{__(this.indexTableRow.state.configurationOpen ? 'Hide' : 'Show')}</span> */}
                                    <span>
                                        {/* <IconArrowDown size={IconArrowDown.Size.Small} /> */}
                                    </span>
                                </div>
                            )}
                        </td>
                    </React.Fragment>
                )}
            </IndexPageContext.Consumer>
        )
    }

    moreConfigurationsClick = (event) => {
        if (this.indexTableRow && this.indexTableRow.openConfigRow) {
            let isOpen = this.indexTableRow.state.configurationOpen || false;
            this.indexTableRow.openConfigRow(!isOpen);
        }
    }
}
